import gql from "graphql-tag";

export const GET_DEALS_COUNT = gql`
  query deals(
    $searchText: String = "%%"
    $type: deal_type_enum
    $business_profile_id: uuid
    $club_profile_id: uuid
    $current_date_time: timestamp
  ) {
    deals_aggregate(
      where: {
        name: { _ilike: $searchText }
        type: { _eq: $type }
        _or: [
          {business_profile_id: { _eq: $business_profile_id }},
           {club_profile_id: { _eq: $club_profile_id }}
         ]
        _and: [
          { manually_end_at: { _is_null: true } }
          { expire_date_time: { _gt: $current_date_time } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
